import { Injectable, inject } from '@angular/core';
import { ServiceInventoryService, ServiceState } from '@brightside-web/desktop/data-access/service-inventory';
import {
  HomeFeedCard,
  HomeFeedSection,
  HomeFeedService,
  selectHomeFeedCardsBySection,
} from '@brightside-web/desktop/feature/home-feed';
import { Subject, combineLatest, filter, takeUntil, tap } from 'rxjs';
import { ChatActionCardComponent } from './home-cards/chat-action-card.component';
import { Store } from '@ngrx/store';

@Injectable({ providedIn: 'root' })
export class ChatActionCardService {
  private _homeFeedService = inject(HomeFeedService);
  private _serviceInventory = inject(ServiceInventoryService);
  private _store = inject(Store);
  private _unsub$ = new Subject<void>();

  private _isCardRegistered: boolean;

  constructor() {
    const service$ = this._serviceInventory
      .getService('chat_action')
      .pipe(filter((service) => !!service && service.state === ServiceState.INITIAL));

    const sectionCards$ = this._store.select(selectHomeFeedCardsBySection(HomeFeedSection.ACTIONS));

    combineLatest([service$, sectionCards$])
      .pipe(
        takeUntil(this._unsub$),
        tap(([service, cards]) => {
          const hasOtherCards = cards.some((card) => card.key !== 'chat_action');
          const chatActionCard = cards.find((card) => card.key === 'chat_action');
        
          if (!hasOtherCards && !chatActionCard && !this._isCardRegistered) {
            this._isCardRegistered = true;
            this.registerChatActionCard();
          } else if ((hasOtherCards || (chatActionCard && cards.length > 1)) && this._isCardRegistered) {
            this._isCardRegistered = false;
            this.removeChatActionCard();
          }
        })
      )
      .subscribe();
  }

  ngOnDestroy() {
    this._unsub$.next();
  }

  private registerChatActionCard() {
    this._homeFeedService.registerHomeFeedCard({
      key: 'chat_action',
      component: 'ChatActionCardComponent',
      componentRef: ChatActionCardComponent,
      order: 0,
      section: HomeFeedSection.ACTIONS,
    });
  }

  private removeChatActionCard() {
    this._homeFeedService.removeHomeFeedCard('chat_action', HomeFeedSection.ACTIONS);
  }
}
